import { createAction, props } from '@ngrx/store';
import { EvaluationSurveyDto } from '@shared/dto';

export const EVALUATION_SURVEY_ACTIONS_TYPE = '@app/evaluation-survey';

export const loadEvaluationSurvey = createAction(
  `${EVALUATION_SURVEY_ACTIONS_TYPE}/load`,
  props<{ refresh?: boolean }>(),
);

export const loadEvaluationSurveySuccess = createAction(
  `${EVALUATION_SURVEY_ACTIONS_TYPE}/load/success`,
  props<{ data: EvaluationSurveyDto[] }>(),
);

export const loadEvaluationSurveyFailure = createAction(
  `${EVALUATION_SURVEY_ACTIONS_TYPE}/load/failure`,
  props<{ error: unknown }>(),
);

export const refreshEvaluationSurvey = createAction(
  `${EVALUATION_SURVEY_ACTIONS_TYPE}/refresh`,
);
